<template>
  <v-card class="px-2 mt-0 main-panel">
    <v-container>
      <v-row
        no-gutters
        align="center"
        class="mt-2"
      >
        <v-col class="headline">
          Terms and Conditions
        </v-col>

        <v-col cols="auto">
          <v-btn
            small
            fab
            icon
            @click="hideModal"
          >
            <v-icon>
              close
            </v-icon>
          </v-btn>
        </v-col>
      </v-row>

      <v-row>
        <v-col>
          <div v-html="copy" />
        </v-col>
      </v-row>

      <v-row
        class="text-center py-2"
        no-gutters
      >
        <v-col>
          <v-btn
            rounded
            dark
            color="grey"
            large
            @click="hideModal"
          >
            Close
          </v-btn>
        </v-col>
      </v-row>
    </v-container>
  </v-card>
</template>
<script lang="ts">
import { Component, Prop, Vue } from 'vue-property-decorator'

import TermsAsset from '@/assets/terms'

@Component
export default class Terms extends Vue {

  copy: string = TermsAsset.copy

  private hideModal () {
    this.$emit('hide')
  }
}
</script>
